<template>
  <Teleport to="main#wrapper">
    <canvas v-once ref="graphics" :width="canvasWidth" :height="canvasHeight" />
  </Teleport>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useWindowSize, useMouse } from '@vueuse/core';
import Particle from './Particle'; // Adjust the import based on your file structure
import { useScrollProgress } from './utils/scrolllogic'; // Import the scroll composable
import { useScreenCursor } from './utils/cursorlogic';
import 'vh-variable';

import { composables } from '@/composables'
const soundDataStore = composables().soundDataStore;

const { documentProgress } = useScrollProgress();

const { width: windowWidth,  height: windowHeight,  } = useWindowSize();
const graphics = ref(null);
const context = computed(() => graphics.value?.getContext('2d', { alpha: true }));
const { screenX, screenY } = useScreenCursor();
const time = ref(2000);
const canvasWidth = computed(() => windowWidth.value);
const canvasHeight = computed(() => windowHeight.value);
const particles = [];

const props = defineProps({
  radius: {
    default: 1,
    type: Number,
  }
});

// Initialize the particle system
onMounted(() => {
  createParticles(1200); // Reduced from 1500 for better performance
  requestAnimationFrame(animate);
});

// Scroll progress

// Animate the particles - optimized version
const animate = () => {
  time.value += 0.1;

  // Cache frequently accessed values to reduce lookups
  const ctx = context.value;
  const w = canvasWidth.value;
  const h = canvasHeight.value;
  const progress = documentProgress.value;
  const t = time.value;
  const cursor = { x: screenX, y: screenY };

  // Clear canvas
  ctx.clearRect(0, 0, w, h);

  // Batch draw all particles
  const len = particles.length;
  for (let i = 0; i < len; i++) {
    particles[i].updateAndDraw(cursor, ctx, progress, t);
  }

  requestAnimationFrame(animate);
};

// Particle system setup
const createParticles = (totalParticles = 80) => {
  const columns = Math.ceil(Math.sqrt(totalParticles * (canvasWidth.value / canvasHeight.value)));
  const rows = Math.ceil(totalParticles / columns);
  const totalRowsWithPhantom = rows + 2;
  const totalColumnsWithPhantom = columns + 1;
  for (let i = 0; i < totalParticles; i++) {
    const x = (canvasWidth.value / totalColumnsWithPhantom) * ((i % columns) + 1);
    const y = (canvasHeight.value / totalRowsWithPhantom) * (Math.floor(i / columns) + 1);
    particles.push(new Particle({ x, y, radius: props.radius, width: canvasWidth.value, height: canvasHeight.value }));
  }
};
</script>

<style scoped>
canvas {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
}

@media (max-width: 1080px) {
  canvas {
    /* top: -20vw;
    right: -10vw;
    left: -10vw;
    width: 120vw;
    height: 120vh; */
  }
}
</style>
